var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex w-full md:inline-flex flex-col items-center overflow-auto",
      attrs: { "data-component": "base-date-time-range-picker" },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      _vm.isSingleCalendarPicker || _vm.isMobile
        ? _c("base-date-time-range-picker-header", {
            attrs: {
              "from-label": _vm.getDateLabel.from,
              "to-label": _vm.getDateLabel.to,
              "active-range-key": _vm.activeRangeKey,
            },
            on: { "select-range-key": _vm.onRangeKeySelect },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex gap-sm w-full md:w-auto" },
        [
          _vm.showPickerFrom
            ? [
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-xs grow mb-sm" },
                  [
                    _c("or-date-time-picker-month-select", {
                      staticClass: "!pb-sm",
                      attrs: { locale: _vm.LOCALE },
                      on: {
                        "update:modelValue": function ($event) {
                          _vm.activeRangeKey = "from"
                        },
                      },
                      model: {
                        value: _vm.initialValueFrom,
                        callback: function ($$v) {
                          _vm.initialValueFrom = $$v
                        },
                        expression: "initialValueFrom",
                      },
                    }),
                    _vm._v(" "),
                    _c("or-date-time-picker-date-select", {
                      staticClass: "!py-sm",
                      attrs: {
                        "model-value": _vm.activeDateModel,
                        locale: _vm.LOCALE,
                        format: _vm.FORMAT,
                        "initial-value": _vm.initialValueFrom,
                        "range-start": _vm.dateFrom || _vm.initialValueFrom,
                        "range-end": _vm.dateTo || _vm.initialValueTo,
                        "date-filter": _vm.dateFromFilter,
                      },
                      on: { "update:modelValue": _vm.onUpdateDateFrom },
                    }),
                    _vm._v(" "),
                    _c("base-time-picker", {
                      attrs: {
                        hours: _vm.time.hoursFrom,
                        minutes: _vm.time.minutesFrom,
                        error: _vm.isTimeError
                          ? _vm.$t(
                              "HITL.agent-ui.search-sessions.date-range-picker.time-error"
                            )
                          : "",
                      },
                      on: {
                        "time-change": function ($event) {
                          return _vm.onTimeChange($event, "from")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showPickerTo
            ? [
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-xs grow mb-sm" },
                  [
                    _c("or-date-time-picker-month-select", {
                      staticClass: "!pb-sm",
                      attrs: { locale: _vm.LOCALE },
                      on: {
                        "update:modelValue": function ($event) {
                          _vm.activeRangeKey = "to"
                        },
                      },
                      model: {
                        value: _vm.initialValueTo,
                        callback: function ($$v) {
                          _vm.initialValueTo = $$v
                        },
                        expression: "initialValueTo",
                      },
                    }),
                    _vm._v(" "),
                    _c("or-date-time-picker-date-select", {
                      staticClass: "!py-sm",
                      attrs: {
                        "model-value": _vm.activeDateModel,
                        locale: _vm.LOCALE,
                        format: _vm.FORMAT,
                        "initial-value": _vm.initialValueTo,
                        "range-start": _vm.dateFrom || _vm.initialValueFrom,
                        "range-end": _vm.dateTo || _vm.initialValueTo,
                        "date-filter": _vm.dateToFilter,
                      },
                      on: { "update:modelValue": _vm.onUpdateDateTo },
                    }),
                    _vm._v(" "),
                    _c("base-time-picker", {
                      attrs: {
                        hours: _vm.time.hoursTo,
                        minutes: _vm.time.minutesTo,
                        error: _vm.isTimeError
                          ? _vm.$t(
                              "HITL.agent-ui.search-sessions.date-range-picker.time-error"
                            )
                          : "",
                      },
                      on: {
                        "time-change": function ($event) {
                          return _vm.onTimeChange($event, "to")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex gap-md justify-between w-full p-sm border-t-1 border-solid border-outline-variant dark:border-outline-variant-dark",
        },
        [
          _c(
            "or-button",
            {
              staticClass: "grow",
              attrs: { variant: _vm.ButtonVariant.Text },
              on: { click: _vm.onCancel },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("HITL.common.actions.cancel")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "or-button",
            {
              staticClass: "grow",
              attrs: { variant: _vm.ButtonVariant.Outlined },
              on: { click: _vm.onDateTimeConfirm },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "HITL.agent-ui.search-sessions.date-range-picker.done-button"
                    )
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }